import React, { Component, ReactNode } from 'react'
import { Link as RouteLink } from 'react-router-dom'
import { routes } from 'config'
import { processErrorMsg } from 'utils'
import { CustomAlert, CustomerSupportNumber, ButtonContainer } from 'components'

interface IProps {
  children: ReactNode
  showLogout?: boolean
  customError?: string
}
interface IState {
  hasError: boolean
}

class ErrorBoundary extends Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    // 2024-03: We found this static method is called by anybody, so static is removed and wait if is needed
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Log the error to an error reporting service
    processErrorMsg(
      error?.toString() || errorInfo.componentStack,
      'Error Boundary',
      'Something went wrong!',
    )
  }

  render() {
    const { hasError } = this.state
    const { children, customError, showLogout } = this.props

    if (hasError || customError) {
      return (
        <>
          <CustomAlert severity="error" title="Something went wrong!">
            Please try again or call customer support for further assistance at{' '}
            <CustomerSupportNumber />
          </CustomAlert>
          {showLogout && (
            <ButtonContainer
              secondary={<RouteLink to={routes.logout}>Logout</RouteLink>}
            />
          )}
        </>
      )
    }

    return children
  }
}

export default ErrorBoundary
